module.exports = __webpack_public_path__ + "static/img/test1.b1e32dac.png";